import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 38"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#222120",
  "fill-rule": "evenodd",
  d: "M18.5.667v9.166h-.013a9.18 9.18 0 1 0 0 18.36h.013v9.14C8.375 37.333.167 29.125.167 19 .167 8.875 8.375.667 18.5.667zm1.833 11L27.667 19l-7.334 7.333zm9.167 0L36.833 19 29.5 26.333z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }